export const TAGGING_FAQ_LIST = [
  {
    faqCategory: 'general',
    catgeoryTitle: 'General',
    faqList: [
      {
        question: `TaggingFAQComponentGeneralQ1`,
        answer: `TaggingFAQComponentGeneralA1`,
      },
      {
        question: `TaggingFAQComponentGeneralQ2`,
        answer: `TaggingFAQComponentGeneralA2`,
      },
      {
        question: `TaggingFAQComponentGeneralQ3`,
        answer: `TaggingFAQComponentGeneralA3`,
      },
      {
        question: `TaggingFAQComponentGeneralQ4`,
        answer: `TaggingFAQComponentGeneralA4`,
      },
    ],
  },
  {
    faqCategory: 'attributes',
    catgeoryTitle: 'Attributes',
    faqList: [
      {
        question: `TaggingFAQComponentAttributesQ1`,
        answer: `TaggingFAQComponentAttributesA1`,
      },
      {
        question: `TaggingFAQComponentAttributesQ2`,
        answer: `TaggingFAQComponentAttributesA2`,
      },
      {
        question: `TaggingFAQComponentAttributesQ3`,
        answer: `TaggingFAQComponentAttributesA3`,
      },
    ],
  },
  {
    faqCategory: 'tags',
    catgeoryTitle: 'Tags',
    faqList: [
      {
        question: `TaggingFAQComponentTagsQ1`,
        answer: `TaggingFAQComponentTagsA1`,
      },
      {
        question: `TaggingFAQComponentTagsQ2`,
        answer: `TaggingFAQComponentTagsA2`,
      },
      {
        question: `TaggingFAQComponentTagsQ3`,
        answer: `TaggingFAQComponentTagsA3`,
      },
    ],
  },
  {
    faqCategory: 'enitites',
    catgeoryTitle: 'Enitites',
    faqList: [
      {
        question: `TaggingFAQComponentEntitiesQ1`,
        answer: `TaggingFAQComponentEntitiesA1`,
      },
      {
        question: `TaggingFAQComponentEntitiesQ2`,
        answer: `TaggingFAQComponentEntitiesA2`,
      },
      {
        question: `TaggingFAQComponentEntitiesQ3`,
        answer: `TaggingFAQComponentEntitiesA3`,
      },
    ],
  },
];

export const DEFAULT_INCIDENTS_PER_100_MILES = 10;
export const DEFAULT_COACHING_INTERVAL = 14;
export const MINIMUM_EVENT_THREASHOLD = 10;
